import { INDUSTRY_PAGE_SLUGS } from "../services/contentApi";

export const CMS_INDUSTRY_PAGES = [
  {
    slug: "mobility",
    name: "Mobility",
    description: "Smart transportation & logistics",
    publicPath: "/mobility",
    accent: "from-blue-500/20 to-blue-600/5",
    accentBorder: "border-blue-200",
    accentDot: "bg-blue-500",
  },
  {
    slug: "healthcare",
    name: "Healthcare",
    description: "Secure digital patient care",
    publicPath: "/healthcare",
    accent: "from-emerald-500/20 to-emerald-600/5",
    accentBorder: "border-emerald-200",
    accentDot: "bg-emerald-500",
  },
  {
    slug: "retail-ecommerce",
    name: "Retail & E-commerce",
    description: "Scalable shopping experiences",
    publicPath: "/retail-ecommerce",
    accent: "from-orange-500/20 to-orange-600/5",
    accentBorder: "border-orange-200",
    accentDot: "bg-orange-500",
  },
  {
    slug: "fintech",
    name: "FinTech",
    description: "High-performance financial systems",
    publicPath: "/fintech",
    accent: "from-cyan-500/20 to-cyan-600/5",
    accentBorder: "border-cyan-200",
    accentDot: "bg-cyan-500",
  },
  {
    slug: "travel-hospitality",
    name: "Travel & Hospitality",
    description: "Seamless booking & engagement",
    publicPath: "/travel-hospitality",
    accent: "from-rose-500/20 to-rose-600/5",
    accentBorder: "border-rose-200",
    accentDot: "bg-rose-500",
  },
  {
    slug: "high-tech-software",
    name: "High-tech & Software",
    description: "Engineering for digital products",
    publicPath: "/high-tech-software",
    accent: "from-indigo-500/20 to-indigo-600/5",
    accentBorder: "border-indigo-200",
    accentDot: "bg-indigo-500",
  },
  {
    slug: "telecom-media",
    name: "Telecom & Media",
    description: "Content delivery & data systems",
    publicPath: "/telecom-media",
    accent: "from-violet-500/20 to-violet-600/5",
    accentBorder: "border-violet-200",
    accentDot: "bg-violet-500",
  },
  {
    slug: "real-estate-construction",
    name: "Real Estate & Construction",
    description: "Modern property management tools",
    publicPath: "/real-estate-construction",
    accent: "from-amber-500/20 to-amber-600/5",
    accentBorder: "border-amber-200",
    accentDot: "bg-amber-500",
  },
  {
    slug: "ai-data-intelligence",
    name: "AI & Data Intelligence",
    description: "Data-driven automation & insights",
    publicPath: "/ai-data-intelligence",
    accent: "from-fuchsia-500/20 to-fuchsia-600/5",
    accentBorder: "border-fuchsia-200",
    accentDot: "bg-fuchsia-500",
  },
];

export const CMS_INDUSTRY_SLUGS = new Set(INDUSTRY_PAGE_SLUGS);

export const INDUSTRY_SECTION_LABELS = [
  { key: "industries-banner", label: "Banner" },
  { key: "challenges", label: "Challenges" },
  { key: "what-we-build", label: "What we build" },
  { key: "relevant-services", label: "Relevant services" },
  { key: "enables", label: "What this enables" },
  { key: "need", label: "CTA" },
];

export function isIndustryPageSlug(slug) {
  return CMS_INDUSTRY_SLUGS.has(String(slug || "").toLowerCase());
}

export function getIndustryPageMeta(slug) {
  return CMS_INDUSTRY_PAGES.find((p) => p.slug === slug) ?? null;
}
